/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-08 16:03:00
 * @LastEditors: caiqin.xie
 * @message: blog-banner组件
 */
import React from "react";
import styles from "../../index.module.scss";
import { Carousel } from '@arco-design/web-react';
import { useDevice } from "@/hooks";
import { IBanner } from "@/common/types";
import LazyMedia from "@/components/LazyMedia";

interface IProps {
  bannerLists: IBanner[];
}

const Banner = (props:IProps) => {
  const {bannerLists} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <>
      {bannerLists && bannerLists.length > 0 && (
        <div className={styles['blog-banner']}>
        <Carousel
          className={styles['banner-carousel']}
          autoPlay={true}
          indicatorType='dot'
          showArrow='hover'>
          {bannerLists.map((item, index) => {
            return (
              <div key={item.id}>
                {
                  item[newDevice].extension === '.mp4'
                  ? <LazyMedia type="video" LazyClassName="full-wh" loop autoPlay preload="auto" playsInline muted src={item[newDevice]?.url}></LazyMedia>
                  : <LazyMedia type="image" LazyClassName="full-wh" src={item[newDevice]?.url} alt={item[newDevice]?.alt} />
                }
              </div>
            )
          })}
        </Carousel>
      </div>
      )}
    </>
    
  )
}
export default Banner
